import { render } from "./TSKSyringe.vue?vue&type=template&id=626924ab&scoped=true"
import script from "./TSKSyringe.vue?vue&type=script&lang=js"
export * from "./TSKSyringe.vue?vue&type=script&lang=js"

import "./TSKSyringe.vue?vue&type=style&index=0&id=626924ab&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626924ab"]])

export default __exports__